const $ = jQuery.noConflict();

class Accordions {
    constructor(trigger) {
        this.trigger = $(trigger);
    }
    init() {
        this.bindEvents();
    }
    bindEvents() {
        this.trigger.on('click', this.toggleAccordion.bind(this));
    }
    toggleAccordion(event) {
        const $currentAccordion = $(event.currentTarget);
        const $parentContainer = $currentAccordion.closest('.page-accordion');
        const $allTriggers = $parentContainer.find(this.trigger);
        const $allPanels = $parentContainer.find('.bellow__content');
        const $parentTabContainer = $currentAccordion.closest('.tabs__tab-content');
        const $allTabTriggers = $parentTabContainer.find(this.trigger);
        const $allTabPanels = $parentTabContainer.find('.bellow__content');
        const $parentSideHeadContainer = $currentAccordion.closest('.block-side-heading-accordion__container');
        const $allSideHeadTriggers = $parentSideHeadContainer.find(this.trigger);
        const $allSideHeadPanels = $parentSideHeadContainer.find('.bellow__content');
        
        $allTriggers.parent().removeClass('active');
        $allPanels.stop().slideUp(250);
        $allTabTriggers.parent().removeClass('active');
        $allTabPanels.stop().slideUp(250);
        $allSideHeadTriggers.parent().removeClass('active');
        $allSideHeadPanels.stop().slideUp(250);
        
        const $contentPanel = $currentAccordion.next();
        if (!$contentPanel.is(':visible')) {
            $currentAccordion.parent().addClass('active');
            $contentPanel.stop().slideDown(250);
        }
    }
}

export default new Accordions('.bellow__title');
